// 平台系统名称配置（集中管理，方便后续调整）
//
// APP_NAME      完整名称，用于 title、说明文案、对外署名
// APP_NAME_SHORT 简称，用于导航条、强调标题等空间受限的地方
// APP_SUBTITLE  副标题/版本标识
// COPYRIGHT     版权署名
// OPERATOR      运营方
export const APP_NAME      = '国地山海价值地图';
export const APP_NAME_SHORT = '国地山海价值地图';
export const APP_SUBTITLE  = '机会账公开版';
export const APP_TAGLINE   = '自然资源资产组合配置服务平台';
export const COPYRIGHT     = `© 2026 ${APP_NAME} · 国地科技`;
export const OPERATOR      = '广东国地规划科技股份有限公司';

// 平台简介页右侧 Hero 图（可配置）
//   - 当前为「新品发布」宣传海报（public/assets/intro-hero.jpg，1600×1280）
//   - 如需换回原来的广东省资源一张图，改回：
//       INTRO_HERO_IMG   = '/data/广东省/全省/masterplan.png'
//       INTRO_HERO_LABEL = '广东省 · 资源一张图'
//   - 容器比例已钉死为原图比例（1028×720），任何图都会 object-fit: cover 自适应填充，版面不变
//   - INTRO_HERO_LABEL 置空字符串可隐藏左上角悬浮标签
export const INTRO_HERO_IMG   = '/assets/intro-hero.jpg';
export const INTRO_HERO_LABEL = '';

// 页脚法律信息（平台简介 / 关于我们等页面最底部展示；ICP 号为标准备案样式，不带前缀）
export const LEGAL_FOOTER = 'Copyright © 2025 广东国地科技股份有限公司 All Rights Reserved. 粤ICP备2023008366号';
